'use strict';

/**
 * @file Adv广告类
 * @author zhangzhe(zhangzhe@baidu.com)
 */

define(['handlebars-loader!templates/adv.html', 'utils/helpers', 'utils/underscore', 'utils/ui', 'utils/css'], function (advTemplate, utils, _, UI, cssUtils) {

    var Adv = function Adv(model, api) {
        this.model = model;
        this.api = api;
        this.imageUrl = '';
        this.setup();
        this.isHide = true;
        this.startAdvPlayed = false;
    };

    _.extend(Adv.prototype, {
        setup: function setup() {
            var html = advTemplate();
            this.el = utils.createElement(html);
            var me = this;
            // 点击广告事件绑定
            utils.addEventListener(this.el, 'click', function () {
                window.open(me.imageUrl);
            }, false);
        },

        loadAdv: function loadAdv(advType) {
            var imageAdvs = this.model.get('imageAdvs');
            if (imageAdvs && imageAdvs[advType] && imageAdvs[advType].image) {
                var img = imageAdvs[advType].image;
                var videoLayer = utils.getElementsByClassName('jw-media', this.api.getContainer())[0];
                var me = this;
                var advStyle = {
                    'display': 'block',
                    'z-index': 1000,
                    'width': '100%',
                    'height': '100%',
                    'top': 0,
                    'left': 0
                };
                if (_.isString(img)) {
                    // encode special characters into URL
                    img = encodeURI(img);
                    advStyle.backgroundImage = 'url("' + img + '")';
                } else {
                    advStyle.backgroundImage = '';
                }
                if (advType === 'end') {
                    advStyle['z-index'] = 0;
                }
                if (advType === 'pause') {
                    var height = videoLayer ? videoLayer.clientHeight : this.model.get('height');
                    var width = videoLayer ? videoLayer.clientWidth : this.model.get('width');
                    advStyle.width = '400px';
                    advStyle.height = '300px';
                    advStyle.top = (height - 300) / 2;
                    advStyle.left = (width - 400) / 2;
                }
                cssUtils.style(this.el, advStyle);
                var closeDiv = utils.getElementsByClassName('adv-close', this.el)[0];
                var countdownDiv = utils.getElementsByClassName('adv-countdown', this.el)[0];
                closeDiv.style.display = 'none';
                countdownDiv.style.display = 'none';
                if (advType === 'start') {
                    var startAdvTime = imageAdvs[advType].time <= 60 ? imageAdvs[advType].time : 60;
                    countdownDiv.style.display = 'block';
                    countdownDiv.innerHTML = '广告: ' + startAdvTime + '秒';
                }
                if (advType === 'pause') {
                    closeDiv.addEventListener('click', function (evt) {
                        me.el.style.display = 'none';
                        evt.stopPropagation();
                    }, false);
                    closeDiv.style.display = 'block';
                }

                this.imageUrl = imageAdvs[advType].url;
                // redraw
                if (this.element()) {
                    this.api.getContainer().replaceChild(this.el, this.element());
                }

                this.isHide = false;
            }
        },

        beginStartAdv: function beginStartAdv() {
            // 如果播放过开场广告了，直接播放视频
            if (this.startAdvPlayed) {
                this.model.loadVideo();
                return;
            }
            var startAdv = this.model.get('imageAdvs').start;
            this.loadAdv('start');
            var initTime = startAdv.time <= 60 ? startAdv.time : 60;
            var advDiv = this.element();
            var me = this;
            var timer = setInterval(function () {
                initTime--;
                if (initTime > 0) {
                    var countdownText = '广告: ' + initTime + '秒';
                    utils.getElementsByClassName('adv-countdown', advDiv)[0].innerHTML = countdownText;
                } else {
                    // 广告播放完成
                    advDiv.style.display = 'none';
                    clearInterval(timer);
                    me.isHide = true;
                    me.startAdvPlayed = true;
                    me.model.loadVideo();
                }
            }, 1000);
        },

        element: function element() {
            var container = this.api.getContainer();
            if (utils.getElementsByClassName('jw-adv', container).length > 0) {
                return utils.getElementsByClassName('jw-adv', container)[0];
            }
            return this.el;
        },

        isHidden: function isHidden() {
            return this.isHide;
        },

        hide: function hide() {
            this.isHide = true;
            this.element().style.display = 'none';
        },

        resizePauseAdv: function resizePauseAdv(playerWidth, playerHeight) {
            cssUtils.style(this.element(), {
                top: (playerHeight - 300) / 2,
                left: (playerWidth - 400) / 2
            });
        }

    });
    return Adv;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/view/adv.js
 ** module id = 200
 ** module chunks = 0
 **/